// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckPicker_wrapper__odJQC"};